export default __webpack_public_path__ + "static/media/logo-rv-login.13da6014.svg";